import styled, { keyframes } from 'styled-components'

/* Animation de rotation continue */
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

/* Animation de pulsation pour le texte */
const pulse = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`

/* Animation d'apparition en fondu */
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

/* Conteneur principal du loader */
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${props => props.$fullScreen ? '100vh' : props.$height || '200px'};
  background-color: ${props => props.$fullScreen ? 'rgba(255, 255, 255, 0.95)' : 'transparent'};

  /* Positionnement selon le mode (plein écran ou normal) */
  position: ${props => props.$fullScreen ? 'fixed' : 'relative'};
  top: ${props => props.$fullScreen ? '0' : 'auto'};
  left: ${props => props.$fullScreen ? '0' : 'auto'};
  right: ${props => props.$fullScreen ? '0' : 'auto'};
  bottom: ${props => props.$fullScreen ? '0' : 'auto'};
  z-index: ${props => props.$fullScreen ? '9999' : '1'};

  /* Animation d'entrée douce */
  animation: ${fadeIn} 0.3s ease-in-out;
`

/* Spinner circulaire animé */
const Spinner = styled.div`
  width: ${props => props.$size || '48px'};
  height: ${props => props.$size || '48px'};
  border: 5px solid ${props => props.theme.colors.backgroundLight};
  border-top: 5px solid ${props => props.theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`

/* Texte optionnel sous le spinner */
const LoaderText = styled.p`
  margin-top: 16px;
  font-size: ${props => props.theme.fontSizes.md || '1rem'};
  color: ${props => props.theme.colors.primary || '#009e60'};
  text-align: center;
  font-weight: 500;
  animation: ${pulse} 1.5s ease-in-out infinite;
`

/* Wrapper pour le contenu du loader */
const LoaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.$fullScreen ? 'white' : 'transparent'};
  padding: ${props => props.$fullScreen ? '2rem' : '0'};
  border-radius: ${props => props.$fullScreen ? '8px' : '0'};
  box-shadow: ${props => props.$fullScreen ? '0 4px 12px rgba(0, 0, 0, 0.1)' : 'none'};
`

/**
 * Composant Loader réutilisable
 * Peut être utilisé en mode normal ou plein écran
 */
const Loader = ({ size, text, fullScreen = false, height }) => {
  return (
    <LoaderContainer $fullScreen={fullScreen} $height={height}>
      <LoaderContent $fullScreen={fullScreen}>
        <Spinner $size={size} />
        {text && <LoaderText>{text}</LoaderText>}
      </LoaderContent>
    </LoaderContainer>
  )
}

export default Loader
